module.exports = __webpack_public_path__ + "img/my-playground-logo.57ed87f6.png";